import { render } from "./headers.vue?vue&type=template&id=7653fc8a&scoped=true"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"

import "./headers.vue?vue&type=style&index=0&id=7653fc8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7653fc8a"],['__file',"src/js/components/headers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7653fc8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7653fc8a', __exports__)) {
    api.reload('7653fc8a', __exports__)
  }
  
  module.hot.accept("./headers.vue?vue&type=template&id=7653fc8a&scoped=true", () => {
    api.rerender('7653fc8a', render)
  })

}


export default __exports__